import Vue from 'vue';
import Vuex from 'vuex';
import AppStore from './modules/AppStoreModule';
import { getModule } from 'vuex-module-decorators';
import RegistrationsStore from './modules/RegistrationsStoreModule';
import TenantsStore from './modules/TenantsStoreModule';
import RegistrationDetailsStore from './modules/RegistrationDetailsStoreModule';
import TenantDetailsStore from './modules/TenantDetailsStoreModule';
import UsersStore from './modules/UsersStoreModule';
import CloudOrganizationsStore from './modules/CloudOrganizationsStoreModule';
import UserDetailsStore from './modules/UserDetailsStoreModule';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    app: AppStore,
    registrations: RegistrationsStore,
    registrationDetails: RegistrationDetailsStore,
    tenants: TenantsStore,
    tenantDetails: TenantDetailsStore,
    users: UsersStore,
    userDetails: UserDetailsStore,
    cloudOrganizations: CloudOrganizationsStore,
  },
});

export default store;

// Register modules
export const AppStoreModule = getModule(AppStore, store);
export const RegistrationsStoreModule = getModule(RegistrationsStore, store);
export const RegistrationDetailsStoreModule = getModule(RegistrationDetailsStore, store);
export const TenantsStoreModule = getModule(TenantsStore, store);
export const TenantDetailsStoreModule = getModule(TenantDetailsStore, store);
export const UsersStoreModule = getModule(UsersStore, store);
export const UserDetailsStoreModule = getModule(UserDetailsStore, store);
export const CloudOrganizationsStoreModule = getModule(CloudOrganizationsStore, store);
